import React from "react";
import { compose } from "ramda";
import ExternalLoginContainer from "./ExternalLoginContainer";
import ExternalLoginPP from "./ExternalLoginPP";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";

const ExternalLoginSwitcher = props => {
  const clientSettings = useSelector(state => state.common.clientSettings);
  return clientSettings && clientSettings.newUIFlag ? (
    <ExternalLoginPP {...props} />
  ) : (
    <ExternalLoginContainer {...props} />
  );
};

export default compose(withRouter)(ExternalLoginSwitcher);



// WEBPACK FOOTER //
// ./components/login/ExternalLoginSwitcher.jsx